goog.provide("shadow.js.shim.module$archiver$default");
shadow.js.shim.module$archiver$default = esm_import$archiver.default;
